/**
 * Defines a conditions to be evaluated using the conversation context.
 */
export class Condition {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
/**
 * Determine the source of a value.
 */
export var ValueSource;
(function (ValueSource) {
    /**
     * The values comes from the user input.
     */
    ValueSource["Input"] = "input";
    /**
     * The value comes from the conversation context.
     */
    ValueSource["Context"] = "context";
    /**
     * The value comes from the identified intention of the user input.
     */
    ValueSource["Intent"] = "intent";
    /**
     * The value comes from the identified entity of the user input.
     */
    ValueSource["Entity"] = "entity";
})(ValueSource || (ValueSource = {}));
/**
 * Define the comparison methods for condition values.
 */
export var ConditionComparison;
(function (ConditionComparison) {
    /**
     * Check for value equality.
     */
    ConditionComparison["Equals"] = "equals";
    /**
     * Check for a not equal value.
     */
    ConditionComparison["NotEquals"] = "notEquals";
    /**
     * Check a substring value.
     */
    ConditionComparison["Contains"] = "contains";
    /**
     * Check if a string starts with the provided value.
     */
    ConditionComparison["StartsWith"] = "startsWith";
    /**
     * Check if a string ends with the provided value.
     */
    ConditionComparison["EndsWith"] = "endsWith";
    /**
     * Check if the numeric value is greater than the provided value.
     */
    ConditionComparison["GreaterThan"] = "greaterThan";
    /**
     * Check if the numeric value is less than the provided value.
     */
    ConditionComparison["LessThan"] = "lessThan";
    /**
     * Check if the numeric value is greater than or equals the provided value.
     */
    ConditionComparison["GreaterThanOrEquals"] = "greaterThanOrEquals";
    /**
     * Check if the numeric value is less than or equals the provided value.
     */
    ConditionComparison["LessThanOrEquals"] = "lessThanOrEquals";
    /**
     * Check if a string matches the provided regular expression.
     */
    ConditionComparison["Matches"] = "matches";
    /**
     * Check if a string matches the provided regular expression.
     */
    ConditionComparison["ApproximateTo"] = "approximateTo";
    /**
     * Check if the users sent any value
     */
    ConditionComparison["Exists"] = "exists";
    /**
     * Check if there is no inputy
     */
    ConditionComparison["NotExists"] = "notExists";
})(ConditionComparison || (ConditionComparison = {}));
/**
 * Define the operators for values comparison.
 */
export var ConditionOperator;
(function (ConditionOperator) {
    /**
     * The comparison is successful if the source value matches any provided value.
     */
    ConditionOperator["Or"] = "or";
    /**
     * The comparison is successful if the source value matches all provided values.
     */
    ConditionOperator["And"] = "and";
})(ConditionOperator || (ConditionOperator = {}));
